import { toast } from '@/view/components/ui/use-toast'
import { MaterialFormValues } from '@/view/pages/Conteudos/hooks/useMaterialForm'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Material } from '../entities/Material'
import { MaterialService } from '../services/materialService'

export const useMaterialMutations = () => {
  const queryClient = useQueryClient()

  const createMutation = useMutation({
    mutationFn: (material: MaterialFormValues) =>
      MaterialService.createMaterial(material),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['materials'] })
      toast({
        title: 'Material criado com sucesso!',
      })
    },
    onError: () => {
      toast({
        variant: 'destructive',
        title: 'Erro ao criar material. Tente novamente mais tarde.',
      })
    },
  })

  const updateMutation = useMutation({
    mutationFn: ({
      materialId,
      material,
      oldMaterial,
    }: {
      materialId: string
      material: MaterialFormValues
      oldMaterial: Material
    }) => MaterialService.updateMaterial(materialId, material, oldMaterial),
    onSuccess: (_, { materialId }) => {
      queryClient.invalidateQueries({
        queryKey: ['material', materialId],
        exact: false,
        refetchType: 'all',
      })
      queryClient.invalidateQueries({ queryKey: ['materials'] })
      toast({
        title: 'Material atualizado com sucesso!',
      })
    },
  })

  const deleteMutation = useMutation({
    mutationFn: (materialId: string) =>
      MaterialService.deleteMaterial(materialId),
    onSuccess: (_, materialId) => {
      queryClient.invalidateQueries({
        queryKey: ['material', materialId],
        exact: false,
        refetchType: 'all',
      })
      queryClient.invalidateQueries({ queryKey: ['materials'] })
      toast({
        title: 'Material deletado com sucesso!',
      })
    },
  })

  const deleteMaterialContent = useMutation({
    mutationFn: ({ materialId, path }: { materialId: string; path: string }) =>
      MaterialService.deleteMaterialContent(materialId, path),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['materials'] })
      toast({
        title: 'Material deletado com sucesso!',
      })
    },
  })

  return {
    createMaterial: createMutation.mutateAsync,
    isCreating: createMutation.isPending,
    updateMaterial: updateMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    deleteMaterial: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
    deleteMaterialContent: deleteMaterialContent.mutateAsync,
    isDeletingMaterialContent: deleteMaterialContent.isPending,
  }
}
